const cards = document.querySelectorAll('.service-card');

if (cards.length) {
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show');
          observer.unobserve(entry.target); // Щоб анімація була один раз
        }
      });
    },
    {
      threshold: 0.2,
    }
  );

  cards.forEach(card => observer.observe(card));
}
